import React, { useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { CITIES, SERVICES } from "./coverageData";
import "leaflet/dist/leaflet.css";

// Fix iconos Leaflet
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });

const CARTO_POSITRON = {
  url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
};

export default function CoverageMap() {
  const mapRef = useRef();

  const openWhatsApp = (city) => {
    const phone = "573225107655";
    const text = encodeURIComponent(`Hola, quiero información sobre cobertura en ${city}`);
    window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
  };

  return (
    <div className="rounded-xl overflow-hidden" style={{ height: 500 }}>
      <MapContainer
        center={[4.711, -74.0721]}
        zoom={6}
        style={{ height: "100%", width: "100%" }}
        ref={mapRef}
      >
        <TileLayer url={CARTO_POSITRON.url} attribution={CARTO_POSITRON.attribution} />
        {CITIES.map((c) => (
          <Marker key={c.key} position={[c.lat, c.lng]}>
            <Popup>
              <div className="font-body">
                <h3 className="font-semibold mb-2">{c.label}</h3>
                <p className="text-xs mb-1">Cobertura a nivel nacional</p>
                <ul className="text-xs list-disc ml-4 mb-2">
                  {SERVICES.map((s) => (
                    <li key={s}>{s}</li>
                  ))}
                </ul>
                <button
                  onClick={() => openWhatsApp(c.label)}
                  className="px-3 py-1 rounded-lg text-white text-xs"
                  style={{ background: "linear-gradient(90deg,#F27E33,#1D2946)" }}
                >
                  Contactar WhatsApp
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
